import {
  EDITOR_TYPE_BUYER_NAME,
  EDITOR_TYPE_ORDER_TAGS,
  EDITOR_TYPE_RECIPIENT_NAME,
  EDITOR_TYPE_ADDRESS_LINE_1,
  EDITOR_TYPE_ADDRESS_LINE_2,
  EDITOR_TYPE_BUYER_ID,
  EDITOR_TYPE_CITY,
  EDITOR_TYPE_CUSTOM_FIELD_1,
  EDITOR_TYPE_CUSTOM_FIELD_2,
  EDITOR_TYPE_CUSTOM_FIELD_3,
  EDITOR_TYPE_INTERNAL_NOTES,
  EDITOR_TYPE_ITEM_NAME,
  EDITOR_TYPE_ITEM_SKU,
  EDITOR_TYPE_NOTES_TO_BUYER,
  EDITOR_TYPE_NOTES_FROM_BUYER,
  EDITOR_TYPE_ORDER_NUMBER,
  EDITOR_TYPE_POSTAL_CODE,
  EDITOR_TYPE_RECIPIENT_COMPANY,
  EDITOR_TYPE_ORDER_SOURCE,
  EDITOR_TYPE_USPS_ZONE,
  EDITOR_TYPE_ADDRESS_VERIFICATION,
  EDITOR_TYPE_ASSIGNED_USER,
  EDITOR_TYPE_LINE_ITEMS,
  EDITOR_TYPE_AMOUNT_PAID,
  EDITOR_TYPE_ORDER_SUBTOTAL,
  EDITOR_TYPE_ORDER_TOTAL,
  EDITOR_TYPE_SHIPPING_PAID,
  EDITOR_TYPE_TAX_PAID,
  EDITOR_TYPE_TOTAL_QUANTITY,
  EDITOR_TYPE_CARRIER,
  EDITOR_TYPE_MARKETPLACE,
  EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED,
  EDITOR_TYPE_STORE,
  EDITOR_TYPE_SHIP_FROM,
  EDITOR_TYPE_SHOPIFY_SHIP_FROM,
  EDITOR_TYPE_DATE_PAID,
  EDITOR_TYPE_SHIP_BY_DATE,
  EDITOR_TYPE_ORDER_DATE,
  EDITOR_TYPE_WAREHOUSE_LOCATION,
  EDITOR_TYPE_SHIP_TO_COUNTRY,
  EDITOR_TYPE_IS_GIFT,
  EDITOR_TYPE_IS_INTERNATIONAL,
  EDITOR_TYPE_STATE,
  EDITOR_TYPE_RESIDENTIAL_INDICATOR,
  EDITOR_TYPE_PACKAGE_TYPE,
  EDITOR_TYPE_SHIPPING_ACCOUNT,
  EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT,
  EDITOR_TYPE_ORDER_WEIGHT,
  EDITOR_TYPE_REQUESTED_SERVICE_MAPPED,
  EDITOR_TYPE_PAYMENT_METHOD,
  EDITOR_TYPE_SELLER_BRAND,
  EDITOR_TYPE_FULFILLMENT_PROVIDER,
  EDITOR_TYPE_DELIVER_BY_DATE,
  EDITOR_TYPE_ORDER_IMPORT_TIME,
} from '../constants/filter-editor-type';

import {
  OPERATOR_TYPE_IS_BLANK,
  OPERATOR_TYPE_IS_NOT_BLANK,
  OPERATOR_TYPE_EQUALS,
  OPERATOR_TYPE_NOT_EQUALS,
  OPERATOR_TYPE_STARTS_WITH,
  OPERATOR_TYPE_DOES_NOT_START_WITH,
  OPERATOR_TYPE_ENDS_WITH,
  OPERATOR_TYPE_DOES_NOT_END_WITH,
  OPERATOR_TYPE_CONTAINS,
  OPERATOR_TYPE_DOES_NOT_CONTAIN,
  OPERATOR_TYPE_INCLUDES,
  OPERATOR_TYPE_DOES_NOT_INCLUDE,
  OPERATOR_TYPE_VALUE_ARE_EMPTY,
  OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY,
  OPERATOR_TYPE_IS_UNKNOWN,
  OPERATOR_TYPE_SHORT_EQUALS,
  OPERATOR_TYPE_SHORT_NOT_EQUALS,
  OPERATOR_TYPE_GREATER_THAN,
  OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_LESS_THAN,
  OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_CURRENT_DATE,
  OPERATOR_TYPE_WITHIN_PAST_X_DAYS,
  OPERATOR_TYPE_WITHIN_NEXT_X_DAYS,
  OPERATOR_TYPE_BEFORE_X_DAYS,
  OPERATOR_TYPE_AFTER_X_DAYS,
  OPERATOR_TYPE_ON_OR_AFTER,
  OPERATOR_TYPE_ON_OR_BEFORE,
  OPERATOR_TYPE_VALUE_EQUALS_TRUE,
  OPERATOR_TYPE_VALUE_EQUALS_FALSE,
  OPERATOR_TYPE_SHIPPING_MY_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT,
  OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT,
  OPERATOR_TYPE_TIME_AT_OR_AFTER,
  OPERATOR_TYPE_TIME_AT_OR_BEFORE,
} from '../constants/filter-operator-type';

const textInputOptions = [
  OPERATOR_TYPE_IS_BLANK,
  OPERATOR_TYPE_IS_NOT_BLANK,
  OPERATOR_TYPE_EQUALS,
  OPERATOR_TYPE_NOT_EQUALS,
  OPERATOR_TYPE_STARTS_WITH,
  OPERATOR_TYPE_DOES_NOT_START_WITH,
  OPERATOR_TYPE_ENDS_WITH,
  OPERATOR_TYPE_DOES_NOT_END_WITH,
  OPERATOR_TYPE_CONTAINS,
  OPERATOR_TYPE_DOES_NOT_CONTAIN,
];

const numberInputOptions = [
  OPERATOR_TYPE_SHORT_EQUALS,
  OPERATOR_TYPE_SHORT_NOT_EQUALS,
  OPERATOR_TYPE_GREATER_THAN,
  OPERATOR_TYPE_GREATER_THAN_OR_EQUAL_TO,
  OPERATOR_TYPE_LESS_THAN,
  OPERATOR_TYPE_LESS_THAN_OR_EQUAL_TO,
];

const dateTimeOptions = [
  OPERATOR_TYPE_CURRENT_DATE,
  OPERATOR_TYPE_WITHIN_PAST_X_DAYS,
  OPERATOR_TYPE_WITHIN_NEXT_X_DAYS,
  OPERATOR_TYPE_BEFORE_X_DAYS,
  OPERATOR_TYPE_AFTER_X_DAYS,
  OPERATOR_TYPE_ON_OR_AFTER,
  OPERATOR_TYPE_ON_OR_BEFORE,
];

const typeToOptionsMap = {
  [EDITOR_TYPE_BUYER_NAME]: textInputOptions,
  [EDITOR_TYPE_ORDER_TAGS]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_DOES_NOT_INCLUDE, OPERATOR_TYPE_VALUE_ARE_EMPTY],
  [EDITOR_TYPE_RECIPIENT_NAME]: textInputOptions,
  [EDITOR_TYPE_ADDRESS_LINE_1]: textInputOptions,
  [EDITOR_TYPE_ADDRESS_LINE_2]: textInputOptions,
  [EDITOR_TYPE_BUYER_ID]: textInputOptions,
  [EDITOR_TYPE_CITY]: textInputOptions,
  [EDITOR_TYPE_CUSTOM_FIELD_1]: textInputOptions,
  [EDITOR_TYPE_CUSTOM_FIELD_2]: textInputOptions,
  [EDITOR_TYPE_CUSTOM_FIELD_3]: textInputOptions,
  [EDITOR_TYPE_INTERNAL_NOTES]: textInputOptions,
  [EDITOR_TYPE_ITEM_NAME]: textInputOptions,
  [EDITOR_TYPE_ITEM_SKU]: textInputOptions,
  [EDITOR_TYPE_NOTES_TO_BUYER]: textInputOptions,
  [EDITOR_TYPE_NOTES_FROM_BUYER]: textInputOptions,
  [EDITOR_TYPE_ORDER_NUMBER]: textInputOptions,
  [EDITOR_TYPE_POSTAL_CODE]: textInputOptions,
  [EDITOR_TYPE_RECIPIENT_COMPANY]: textInputOptions,
  [EDITOR_TYPE_ORDER_SOURCE]: textInputOptions,
  [EDITOR_TYPE_USPS_ZONE]: numberInputOptions,
  [EDITOR_TYPE_WAREHOUSE_LOCATION]: textInputOptions,
  [EDITOR_TYPE_ADDRESS_VERIFICATION]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_IS_UNKNOWN],
  [EDITOR_TYPE_ASSIGNED_USER]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_LINE_ITEMS]: numberInputOptions,
  [EDITOR_TYPE_AMOUNT_PAID]: numberInputOptions,
  [EDITOR_TYPE_ORDER_SUBTOTAL]: numberInputOptions,
  [EDITOR_TYPE_ORDER_TOTAL]: numberInputOptions,
  [EDITOR_TYPE_SHIPPING_PAID]: numberInputOptions,
  [EDITOR_TYPE_TAX_PAID]: numberInputOptions,
  [EDITOR_TYPE_TOTAL_QUANTITY]: numberInputOptions,
  [EDITOR_TYPE_CARRIER]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_VALUE_ARE_EMPTY, OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY],
  [EDITOR_TYPE_MARKETPLACE]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED]: textInputOptions,
  [EDITOR_TYPE_STORE]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_SHIP_FROM]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_SHOPIFY_SHIP_FROM]: textInputOptions,
  [EDITOR_TYPE_DATE_PAID]: dateTimeOptions,
  [EDITOR_TYPE_SHIP_BY_DATE]: dateTimeOptions,
  [EDITOR_TYPE_ORDER_DATE]: dateTimeOptions,
  [EDITOR_TYPE_SHIP_TO_COUNTRY]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_DOES_NOT_INCLUDE],
  [EDITOR_TYPE_IS_GIFT]: [OPERATOR_TYPE_VALUE_EQUALS_TRUE, OPERATOR_TYPE_VALUE_EQUALS_FALSE],
  [EDITOR_TYPE_IS_INTERNATIONAL]: [OPERATOR_TYPE_VALUE_EQUALS_TRUE, OPERATOR_TYPE_VALUE_EQUALS_FALSE],
  [EDITOR_TYPE_STATE]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_DOES_NOT_INCLUDE],
  [EDITOR_TYPE_RESIDENTIAL_INDICATOR]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_PACKAGE_TYPE]: [OPERATOR_TYPE_INCLUDES],
  [EDITOR_TYPE_SHIPPING_ACCOUNT]: [
    OPERATOR_TYPE_SHIPPING_MY_ACCOUNT,
    OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT,
    OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT,
  ],
  [EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT]: [
    OPERATOR_TYPE_SHIPPING_MY_ACCOUNT,
    OPERATOR_TYPE_SHIPPING_RECIPIENT_ACCOUNT,
    OPERATOR_TYPE_SHIPPING_THIRD_PARTY_ACCOUNT,
  ],
  [EDITOR_TYPE_ORDER_WEIGHT]: numberInputOptions,
  [EDITOR_TYPE_REQUESTED_SERVICE_MAPPED]: [OPERATOR_TYPE_INCLUDES, OPERATOR_TYPE_DOES_NOT_INCLUDE, OPERATOR_TYPE_VALUE_ARE_EMPTY],
  [EDITOR_TYPE_PAYMENT_METHOD]: textInputOptions,
  [EDITOR_TYPE_SELLER_BRAND]: [
    OPERATOR_TYPE_INCLUDES,
    OPERATOR_TYPE_DOES_NOT_INCLUDE,
    OPERATOR_TYPE_VALUE_ARE_EMPTY,
    OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY,
  ],
  [EDITOR_TYPE_FULFILLMENT_PROVIDER]: [
    OPERATOR_TYPE_INCLUDES,
    OPERATOR_TYPE_DOES_NOT_INCLUDE,
    OPERATOR_TYPE_VALUE_ARE_EMPTY,
    OPERATOR_TYPE_VALUE_ARE_NOT_EMPTY,
  ],
  [EDITOR_TYPE_DELIVER_BY_DATE]: dateTimeOptions,
  [EDITOR_TYPE_ORDER_IMPORT_TIME]: [OPERATOR_TYPE_TIME_AT_OR_AFTER, OPERATOR_TYPE_TIME_AT_OR_BEFORE],
};

export const getOptionsForFilterOperatorByEditorType = (editorType) => {
  return typeToOptionsMap[editorType];
};
